import {type CardEnum, type CardStateOrdered} from './CardState.ts'

export enum PlayerColor {
    None = 0,
    Red = 1,
    Blue = 2,
    Orange = 3,
    Green = 4,
    Black = 5,
    Bronze = 6,
    Silver = 7,
    Gold = 8,
    White = 9,
    Purple = 10,
    MysticBlue = 11,
    Pink = 12,
}

export enum VictoryPointType {
    Settlement = 0,
    City = 1,
    DevelopmentCardVictoryPoint = 2,
    LargestArmy = 3,
    LongestRoad = 4,
    Chits = 5,
    Metropolis = 6,
    DefenderOfColonist = 7,
    ProgressCardVictoryPoint = 8,
    Merchant = 9,
}

export interface PlayerState {
    readonly color: PlayerColor
    readonly victoryPointsState: {[key in VictoryPointType]?: number}
    readonly bankTradeRatiosState: {[key in CardEnum]?: number}
    readonly resourceCards: CardStateOrdered

    cardDiscardLimit: number
    isTakingAction: boolean
    isConnected: boolean
}

export type VictoryPointState = {[key in VictoryPointType]?: number}
